import { Radio } from "antd";
import type { RadioProps } from "antd";

export type UIRadioProps = RadioProps;

export const UIRadio = (props: UIRadioProps) => <Radio {...props} />;
